<template>
    <div class="ps-page-body">
        <SeoHead
            :title="title || 'Blog'"
            description="Product updates, tutorials, and tips for print cards, digital presence, and lead capture with ProfileSuite."
        />

        <marketing-page-hero
            eyebrow="Insights"
            :title="__('Blogs & News')"
            :lead="__('Updates, tutorials, and ideas for building cards, pages, and lead flows with ProfileSuite.')"
        />

        <section class="ps-page-body__section">
            <div class="container">
                <div v-if="posts.data.length" class="-mx-4 flex flex-wrap">
                    <div v-for="post in posts.data" :key="post.id" class="w-full px-4 md:w-1/2 lg:w-1/3">
                        <div class="group mb-10">
                            <div class="mb-8 overflow-hidden rounded-xl">
                                <Link :href="route('blog.details', post.id)" class="block">
                                    <img
                                        v-if="post.image"
                                        :src="post.image"
                                        alt=""
                                        class="w-full aspect-[16/10] object-cover transition duration-300 group-hover:scale-105"
                                    >
                                </Link>
                            </div>
                            <div>
                                <span class="mb-4 inline-block rounded-full bg-emerald-50 py-1 px-3 text-center text-xs font-semibold text-emerald-700">
                                    {{ moment(post.created_at).format('MMM DD, YYYY') }}
                                </span>
                                <h3>
                                    <Link
                                        :href="route('blog.details', post.id)"
                                        class="mb-3 inline-block text-xl font-bold text-slate-900 hover:text-emerald-700 transition-colors sm:text-2xl"
                                    >
                                        {{ post.title }}
                                    </Link>
                                </h3>
                                <p class="text-base text-slate-600 leading-relaxed">
                                    {{ post.details.length < 120 ? post.details : post.details.substring(0, 120) + '…' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-else class="text-center text-slate-500 py-16">{{ __('No blog posts yet.') }}</p>
                <pagination class="mt-6" :links="posts.links" />
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Landing/Layout'
import MarketingPageHero from '@/Shared/Landing/MarketingPageHero'
import SeoHead from '@/Shared/SeoHead'
import Pagination from '@/Shared/Landing/Pagination'
import { Link } from '@inertiajs/vue3'
import moment from 'moment'

export default {
    layout: Layout,
    components: {
        MarketingPageHero,
        SeoHead,
        Pagination,
        Link,
    },
    props: {
        posts: Object,
        title: String,
    },
    created() {
        this.moment = moment
    },
}
</script>
